import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintBAST = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocBAST = ({ innerRef, item, type }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          BERITA ACARA SERAH TERIMA
          <br />
          RUMAH SEJAHTERA TAPAK / SATUAN RUMAH SEJAHTERA SUSUN*)
        </div>
        <div style={{ height: "2px", width: "100%", backgroundColor: "black", marginBottom: "10px" }}></div>
        <div style={{ padding: "20px" }}>
          <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <div style={{ verticalAlign: "top" }}>Nomor :</div>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Pada tanggal,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;telah dilakukan serah terima dari :</td>
              </tr>
            </tbody>
          </table>

          <table style={{ borderCollapse: "collapse", marginTop: "20px", marginBottom: "20px", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <div style={{ verticalAlign: "top", fontWeight: "bold" }}>PT. HIKMAH ALAM SENTOSA</div>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>
                  (selanjutnya disebut <span style={{ fontWeight: "bold" }}>”Pihak Pertama”</span>);
                </td>
              </tr>
            </tbody>
          </table>

          <p>Kepada :</p>
          <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                  <td style={{ verticalAlign: "top", width: "150px" }}>Nama</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{item.sls_appl?.name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                  <td style={{ verticalAlign: "top", width: "150px" }}>NIK</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{item.sls_appl?.identity ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                  <td style={{ verticalAlign: "top", width: "150px" }}>Alamat</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{item.sls_appl?.address ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>4.</td>
                  <td style={{ verticalAlign: "top", width: "150px" }}>No Telp/HP</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{item.sls_appl?.phone ?? "-"}</td>
                </tr>
              </tbody>
            </table>
            <div>
              Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Pihak Kedua”</span>)
            </div>
          </div>
          <div>
            Berdasarkan PPJB/AJB*).................... No .............................. Tanggal :<br />
            Atas 1 (satu) unit Rumah Sejahtera Tapak/Satuan Rumah Sejahtera Susun*) pada lokasi sebagai berikut :
          </div>
          <div style={{ marginBottom: "20px", marginLeft: "20px" }}>
            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>Nama Perumahan/Tower</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  {item.sales_branch?.name ?? "-"}
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>Lantai / No. Unit</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{item.sales_detail?.[0]?.sales_detail_product?.product_block?.name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>Luas Lantai Bersih (Netto)</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>{item.sales_detail?.[0]?.sales_detail_product?.product_category?.name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>4.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>Alamat</td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  {item.sales_branch?.branch_address[0]?.description}
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>5.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>Kota/Kabupaten/Provinsi </td>
                  <td style={{ width: "15px", padding: "2px 4px", verticalAlign: "top" }}>:</td>
                  <td>Bogor – Jawa Barat</td>
                </tr>
              </tbody>
            </table>
            <div>
              Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Objek Serah Terima”</span>)
            </div>
          </div>

          <div>Adapun serah terima atas Objek Serah Terima dilakukan dengan syarat dan ketentuan sebagai berikut : </div>
          <div style={{ marginBottom: "20px" }}>
            <table style={{ borderCollapse: "collapse", tableLayout: "fixed" }}>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>1.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>.........................</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>2.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>.........................</td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "top", width: "20px" }}>3.</td>
                  <td style={{ verticalAlign: "top", width: "250px" }}>.........................</td>
                </tr>
              </tbody>
            </table>
            <div>
              Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Objek Serah Terima”</span>)
            </div>
          </div>

          <div
            style={{
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
              }}
            >
              <div>
                PIHAK PERTAMA /KUASA*),
                <br />
                PT. HIKMAH ALAM SENTOSA
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
              }}
            >
              <div>PIHAK KEDUA,</div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                  Materai
                  <br />
                  10.000,-
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
              }}
            >
              <div>ANGGA BUDI KUSUMA</div>
            </div>
            <div
              style={{
                marginTop: "25px",
                width: "88px",
              }}
            >
              <div>{item.sls_appl?.name ?? "-"}</div>
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            *) Pilih salah satu <br />
            *diberikan cap perusahaan/instansi
          </div>
        </div>
      </div>
    </div>
  );
};
